import { render } from "./Journal.vue?vue&type=template&id=7e53de68"
import script from "./scripts/journal.ts?vue&type=script&language=ts&lang=js"
export * from "./scripts/journal.ts?vue&type=script&language=ts&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__